// extracted by mini-css-extract-plugin
export default {"newsItem":"NewsItem_newsItem__Mfymm","newsDate":"NewsItem_newsDate__V0Yf6"};